"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkNode = exports.createNetworkNode = void 0;
const ExternalNetworkRpc_1 = require("./logic/ExternalNetworkRpc");
const NetworkStack_1 = require("./NetworkStack");
const createNetworkNode = (opts) => {
    return new NetworkNode(new NetworkStack_1.NetworkStack(opts));
};
exports.createNetworkNode = createNetworkNode;
/**
 * Convenience wrapper for building client-facing functionality. Used by client.
 */
class NetworkNode {
    stack;
    stopped = false;
    externalNetworkRpc;
    /** @internal */
    constructor(stack) {
        this.stack = stack;
    }
    async start(doJoin) {
        await this.stack.start(doJoin);
        this.externalNetworkRpc = new ExternalNetworkRpc_1.ExternalNetworkRpc(this.stack.getControlLayerNode().getTransport());
    }
    async inspect(node, streamPartId) {
        return this.stack.getContentDeliveryManager().inspect(node, streamPartId);
    }
    async broadcast(msg, streamPartDeliveryOptions) {
        await this.stack.broadcast(msg, streamPartDeliveryOptions);
    }
    async join(streamPartId, neighborRequirement, streamPartDeliveryOptions) {
        await this.stack.joinStreamPart(streamPartId, neighborRequirement, streamPartDeliveryOptions);
    }
    async setProxies(streamPartId, nodes, direction, userId, connectionCount) {
        await this.stack.getContentDeliveryManager().setProxies(streamPartId, nodes, direction, userId, connectionCount);
    }
    isProxiedStreamPart(streamPartId) {
        return this.stack.getContentDeliveryManager().isProxiedStreamPart(streamPartId);
    }
    addMessageListener(listener) {
        this.stack.getContentDeliveryManager().on('newMessage', listener);
    }
    setStreamPartEntryPoints(streamPartId, contactPeerDescriptors) {
        this.stack.getContentDeliveryManager().setStreamPartEntryPoints(streamPartId, contactPeerDescriptors);
    }
    removeMessageListener(listener) {
        this.stack.getContentDeliveryManager().off('newMessage', listener);
    }
    async leave(streamPartId) {
        if (this.stopped) {
            return;
        }
        await this.stack.getContentDeliveryManager().leaveStreamPart(streamPartId);
    }
    getNeighbors(streamPartId) {
        return this.stack.getContentDeliveryManager().getNeighbors(streamPartId);
    }
    hasStreamPart(streamPartId) {
        return this.stack.getContentDeliveryManager().hasStreamPart(streamPartId);
    }
    async stop() {
        this.stopped = true;
        this.externalNetworkRpc.destroy();
        await this.stack.stop();
    }
    getPeerDescriptor() {
        return this.stack.getControlLayerNode().getLocalPeerDescriptor();
    }
    getMetricsContext() {
        return this.stack.getMetricsContext();
    }
    getNodeId() {
        return this.stack.getContentDeliveryManager().getNodeId();
    }
    getOptions() {
        return this.stack.getOptions();
    }
    getStreamParts() {
        return this.stack.getContentDeliveryManager().getStreamParts();
    }
    async fetchNodeInfo(node) {
        return this.stack.fetchNodeInfo(node);
    }
    getDiagnosticInfo() {
        return {
            controlLayer: this.stack.getControlLayerNode().getDiagnosticInfo(),
            contentLayer: this.stack.getContentDeliveryManager().getDiagnosticInfo()
        };
    }
    registerExternalNetworkRpcMethod(request, response, name, fn) {
        this.externalNetworkRpc.registerRpcMethod(request, response, name, fn);
    }
    createExternalRpcClient(clientClass) {
        return this.externalNetworkRpc.createRpcClient(clientClass);
    }
}
exports.NetworkNode = NetworkNode;
//# sourceMappingURL=NetworkNode.js.map